import React from 'react';
import styled from "styled-components";
import ImageContainer from '../Paradox/ImageContainer'
import One from '../../images/guilty/1.jpg'
import Two from '../../images/guilty/2.jpg'
import Three from '../../images/guilty/3.jpg'
import Four from '../../images/guilty/4.jpg'
import Five from '../../images/guilty/5.jpg'
import Six from '../../images/guilty/6.jpg'
import Seven from '../../images/guilty/7.jpg'
import Eight from '../../images/guilty/8.jpg'
import Nine from '../../images/guilty/9.jpg'
import Ten from '../../images/guilty/10.jpg'
import Eleven from '../../images/guilty/11.jpg'
import Twelve from '../../images/guilty/12.jpg'
import Thirteen from '../../images/guilty/13.jpg'


const ImagesContainer = styled.div`
  width: 100%;
  margin: 0;
  overflow-x: hidden;
`
const TextWrapper = styled.div`
  padding-top: 50px;
  padding-left: 10%;
  padding-right: 10%;
  @media screen and (max-width: 425px) {
    width: 100%;
  }
`;

const ParadoxImageContainer = ({refs}) => {
  return (
    <ImagesContainer ref={refs}>
      <TextWrapper>
        <p>“Inception,” “War and Peace,” Phoebe Bridgers, “Ratatouille” — there are works of art and artists that we know are great and deserve the highest praise… then there’s “Fifty Shades of Grey.” The “Guilty Pleasures” B-Side honors the underbelly of our tastes. The loves that we’re a little less proud of, or at least that’s how we’ve been told to feel. Whether it’s because they are silly or indulgent, gross or morally ambiguous, guilty pleasures are inescapable, mysterious joys that we wrestle with given others’ expectations. Articles explore our writers’ relationships with their own guilty pleasures, question the concept entirely or both — you won’t feel guilty reading any of them.</p>
        {/* <em>— Andrew Pluta, Senior Arts Editor</em> */}
      </TextWrapper>
      <ImageContainer images={[One, Two, Three]} links={["https://www.michigandaily.com/section/bside/guilty-pleasures-university-michigan", "https://www.michigandaily.com/section/bside/fun-play-not-eat-pleasures-pimple-popping", "https://www.michigandaily.com/section/bside/museum-your-imagination-dancing-guilty-pleasure"]}></ImageContainer>
      <ImageContainer images={[Four, Five, Six]} links={["https://www.michigandaily.com/section/bside/hunger-games-critiques-celebrity-culture-americas-guilty-pleasure", "https://www.michigandaily.com/section/bside/complex-feels-gordon-ramseys-kitchen-nightmares", "https://www.michigandaily.com/section/bside/joy-barbie-movies-and-other-things-you-love"]}></ImageContainer>
      <ImageContainer images={[Seven, Eight, Nine]} links={["https://www.michigandaily.com/section/bside/once-scene-kid-always-scene-kid", "https://www.michigandaily.com/section/bside/cancelled-artist", "https://www.michigandaily.com/section/bside/jersey-shore-exploits-entertainment"]}></ImageContainer>
      <ImageContainer images={[Ten, Eleven, Twelve, Thirteen]} links={["https://www.michigandaily.com/section/bside/la-sobremesa-guilty-pleasure-self-indulgence", "https://www.michigandaily.com/section/bside/glee-fandom-and-loving-something-so-much-its-embarrassing", "https://www.michigandaily.com/section/bside/dissecting-guilty-pleasure-2000s-music-nostalgia", "https://www.michigandaily.com/section/bside/what-guilty-pleasure"]}></ImageContainer>
    </ImagesContainer>
  );
}

export default ParadoxImageContainer;